import { c as _c } from "react/compiler-runtime";
import type { TouchWeightAnalyzedKeyboard } from '@/lib/piano/touch-design/touch-weight-key-analysis';
import type { TouchDesignSerie } from '@/components/charts/interfaces';
import { useGenerateSerie } from '@/components/charts/hooks/use-generate-serie';
import { useCallback, useMemo } from 'react';
import { TouchDesignSerieVariant } from '@/components/charts/KeyboardChart';
import { StrikeWeightRatioDesignMode, type StrikeWeightRatioDesignTarget } from '@/lib/piano/touch-design/design/strike-weight-ratio-design';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
import { useSmoothedSerieAverage } from '@/components/charts/hooks/use-smoothed-serie-average';
import { useTranslation } from '@/hooks/use-translation';
export const useStrikeWeightRatioTargetSerie = keyboard => {
  const $ = _c(13);
  const {
    t
  } = useTranslation();
  const {
    generateSerie
  } = useGenerateSerie(keyboard);
  const {
    smoothMean,
    smoothMedian
  } = useSmoothedSerieAverage();
  let t0;
  if ($[0] !== t) {
    t0 = t("Target");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const name = t0;
  const variant = TouchDesignSerieVariant.Target;
  let t1;
  if ($[2] !== generateSerie || $[3] !== name) {
    t1 = generateSerie(_temp, name, variant);
    $[2] = generateSerie;
    $[3] = name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const nullTargetSerie = t1;
  let t2;
  if ($[5] !== generateSerie || $[6] !== name || $[7] !== nullTargetSerie || $[8] !== smoothMean || $[9] !== smoothMedian) {
    t2 = (mode, target) => {
      if (mode === StrikeWeightRatioDesignMode.AsMeasured) {
        return generateSerie(_temp2, name, variant);
      }
      if (mode === StrikeWeightRatioDesignMode.FixedValue && target !== null && !isNaN(target as number)) {
        return generateSerie(() => target as number, name, variant);
      }
      const baseSerie = generateSerie(_temp3, name, variant);
      if (mode === StrikeWeightRatioDesignMode.Smoothed && target === SmoothStrategy.Mean) {
        return smoothMean(baseSerie);
      }
      if (mode === StrikeWeightRatioDesignMode.Smoothed && target === SmoothStrategy.Median) {
        return smoothMedian(baseSerie);
      }
      return nullTargetSerie;
    };
    $[5] = generateSerie;
    $[6] = name;
    $[7] = nullTargetSerie;
    $[8] = smoothMean;
    $[9] = smoothMedian;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const generateStrikeWeightRatioTargetSerie = t2;
  let t3;
  if ($[11] !== generateStrikeWeightRatioTargetSerie) {
    t3 = {
      generateStrikeWeightRatioTargetSerie
    };
    $[11] = generateStrikeWeightRatioTargetSerie;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
function _temp() {
  return null;
}
function _temp2(key) {
  return key.payload.strikeWeightRatio;
}
function _temp3(key_0) {
  return key_0.payload.strikeWeightRatio;
}